import defaultClient from '@src/api/clients/default';

const URL = (path) => {
  return `dashboard/day-of-week/${path}/`;
};

export function fetchDayOfWeekByWeekday(payload = {}) {
  return defaultClient.request({
    url: URL('weekday'),
    payload,
  });
}

export function fetchDayOfWeekByDate(payload = {}) {
  return defaultClient.request({
    url: URL('date'),
    payload,
  });
}

export function fetchDayOfWeekByClient(payload = {}) {
  return defaultClient.request({
    url: URL('client'),
    payload,
  });
}
